import React from 'react';
import about from '../assets/images/services/interior/interior-design.jpg';
import AnimatedSection from './common/AnimatedSection';

function About() {
  return (
    <AnimatedSection
      id="about"
      className="flex flex-col md:flex-row items-center justify-between px-6 md:px-16 py-20 gap-14 bg-gray-50 overflow-hidden"
    >
      {/* Image Section */}
      <div className="flex-1 flex justify-center items-center animate-slide-in-left">
        <div className="rounded-xl overflow-hidden shadow-xl max-w-md w-full">
          <img
            src={about}
            alt="Architectural Concept"
            className="object-cover w-full h-full"
          />
        </div>
      </div>

      {/* Text Section */}
      <div className="flex-1 animate-slide-in-right">
        <div className="mb-6">
          <h2 className="text-xl md:text-3xl font-bold bg-gradient-to-r from-primary-dark to-primary-light bg-clip-text text-transparent">
            Building Tomorrow, Today
          </h2>
          <div className="h-1 w-24 mt-4 bg-teal-600 rounded" />
        </div>

        <p className="text-lg md:text-lg font-light leading-relaxed text-gray-700 mb-6 text-justify">
          <span className="font-black text-teal-950">EDGES DESIGN GROUP</span>, we specialize in bringing visionary architectural and construction concepts to life. With a team of skilled architects, engineers, and builders, we merge innovation with practicality to deliver spaces that inspire and endure.
        </p>

        <p className="text-lg md:text-xl font-light leading-relaxed text-gray-700 mb-6 text-justify">
          Whether it's urban planning, structural execution, or residential and commercial developments, our approach blends aesthetics, sustainability, and precision to ensure excellence in every phase—from blueprint to build.
        </p>

        <button className="text-white text-sm bg-primary-dark px-6 py-3 rounded-md font-bold shadow-lg hover:bg-primary-light transition">
          Learn more <i className="fa fa-angle-double-right ml-2" />
        </button>
      </div>
    </AnimatedSection>
  );
}

export default About;
